<template>
  <div class="page-wrapper">
    <img src="../image/ajax-loader.gif" v-show="waitingApiRequestsCount != 0"
         style="margin: 0; position: absolute; top: 50%; left: 50%; margin-right: -50%; transform: translate(-50%, -50%); z-index: 10">
    <menu-dispatcher></menu-dispatcher>
    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="workers-base-container">
        <div class="cabinet">
          <div class="cabinet-head schedule-head visibility">
            <div class="title">Рабочие в смене</div>
          </div>
          <div class="cabinet-body">
            <div class="cabinet-info">
              <div class="cabinet-settings schedule-filter">
                <div class="visibility">
                  <div class="date-select block">
                    <fieldset>
                      <div class="block-icon">
                        <span class="icon"><i class="fa fa-calendar-o"></i></span>
                        <date-picker
                                v-model="dateFilter"
                                ref="datePicker"
                                format="DD.MM.YYYY"
                                lang="ru"
                                v-mask="'##.##.####'"
                                placeholder="__.__.____"
                                :clearable="false"
                                :first-day-of-week="1"
                                @input="updateWorkersWithStartOfDay">
                        </date-picker>
                      </div>
                    </fieldset>
                  </div>
                  <div class="area-select block block-icon">
                    <span class="icon"><i class="fa fa-map-marker"></i></span>
                    <select v-model="endDistrictFilter" @change="updateWorkersInShiftList">
                      <option :value="null">Район</option>
                      <option v-for="district in districts" :value="district.name">
                        {{ district.name }}
                      </option>
                    </select>
                  </div>
                  <div class="dop-block visibility">
                    <div class="type block">
                      <select v-model="workerTypeFilter">
                        <option :value="null">Тип исполнителя</option>
                        <option v-for="workerType in workerTypes" :value="workerType.code">{{ workerType.name }}
                        </option>
                      </select>
                    </div>
                    <div class="category block">
                      <select v-model="workerCategoryFilter">
                        <option :value="null">Категория</option>
                        <option v-for="category in categories" :value="category">
                          {{ category.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cabinet-box">
                <div class="cabinet-table">
                  <table cellpadding="0" cellspacing="0" class="workers-schedule">
                    <thead>
                    <tr>
                      <td class="period">Время</td>
                      <td class="summ">Свободны</td>
                      <td class="summ">Требуют распределения</td>
                      <td>Список рабочих</td>
                      <td class="area">Район завершения</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(workersInShift, index) in workersInShiftList">
                      <td class="period">
                        {{ moment(workersInShift.periodFrom) }} - {{ moment(workersInShift.periodTo) }}
                      </td>
                      <td class="summ">{{ filteredFreeWorkers(index).length }}</td>
                      <td class="summ">{{ filteredFreeOrderTos(index).length }}</td>
                      <td class="worker" colspan="2">
                        <table class="worker-list" cellpadding="0" cellspacing="0">
                          <tr v-for="freeWorker in filteredFreeWorkers(index)"
                              v-if="freeWorker.becameAvailableInThisPeriod">
                              <td class="worker-info">
                                <span v-if="freeWorker.exactlyFree" class="free-worker"></span>
                              <a class="name"
                                 @click="$router.push(`/workers-base/worker-card/${freeWorker.id}`)">
                                {{ freeWorker.surname + ' ' + freeWorker.name + ' ' + freeWorker.patronymic }},</a>
                              <div class="dop-info">
                                <span class="type">{{ freeWorker.type.name }},</span><span class="category">{{ getWorkerCategories(freeWorker) }},</span>
                                <span
                                  class="phone">{{ freeWorker.phone }},</span><span class="time">{{ moment(freeWorker.lastTime) }}</span>
                              </div>
                            </td>
                            <td class="area">{{ freeWorker.endDistrict }}</td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MenuDispatcher from '@/components/MenuDispatcher.vue'
  import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
  import api from '@/api'
  import moment from 'moment'
  import DatePicker from 'vue2-datepicker'
  import {mask} from 'vue-the-mask'
  import utils from '@/utils'

  export default {
  name: 'WorkersInShift',
  components: {
    MenuDispatcher,
    HeaderDispatcher,
    DatePicker
  },

    directives: {mask},

  data () {
    return {
      dateFilter: new Date(),
      endDistrictFilter: null,
      workerTypeFilter: null,
      workerCategoryFilter: null,
      workerTypes: [],
      truckingCategories: [],
      furnitureCategories: [],
      moverCategories: [],
      garbageCategories: [],
      districts: [],

      workersInShiftList: []
    }
  },

  computed: {
    waitingApiRequestsCount () {
      return this.$store.getters.waitingApiRequestsCount
    },

    categories () {
      switch (this.workerTypeFilter) {
        case 'driver':
          return this.truckingCategories
        case 'furniture':
          return this.furnitureCategories
        case 'mover':
          return this.moverCategories
        case 'garbage':
          return this.garbageCategories
        default:
          return []
      }
    }
  },

  watch: {
    workerTypeFilter () {
      this.workerCategoryFilter = null
    }
  },

  mounted () {
    document.body.classList.add('cabinet-page')

    this.updateWorkersInShiftList()
    this.updateWorkerTypes()
    this.updateCategories()
    this.updateDistricts()
    this.addDatePickerWatcher();
  },

  destroyed () {
    document.body.classList.remove('cabinet-page')
  },

  methods: {
    getWorkerCategories (worker) {
      return worker.categories ? worker.categories.join(', ') : ''
    },

    filteredFreeWorkers (index) {
      return this.workersInShiftList[index].freeWorkers
        .filter(w => {
          return this.workerTypeFilter == null || w.type.code === this.workerTypeFilter
        })
        .filter(w => {
          return this.workerCategoryFilter == null || w.categories.indexOf(this.workerCategoryFilter.name) > -1
        })
    },

    filteredFreeOrderTos (index) {
      return this.workersInShiftList[index].freeOrderTos
        .filter(o => {
          return this.workerTypeFilter == null || this.equalOrderToAndWorkerType(o.type, this.workerTypeFilter)
        })
        .filter(o => {
          return this.workerCategoryFilter == null || o.category.id === this.workerCategoryFilter.id
        })
    },

    updateWorkersInShiftList () {
      api
        .getWorkersInShift(this.dateFilter.getTime(), this.endDistrictFilter)
        .then((workersInShiftList) => {
          if (workersInShiftList) { this.workersInShiftList = workersInShiftList }
        })
        .catch(err => alert(err))
    },

    updateWorkersWithStartOfDay (value) {
      value.setHours(0, 0, 0, 0)
      this.dateFilter = value
      this.updateWorkersInShiftList()
    },

    updateWorkerTypes () {
      api
        .getWorkerTypes()
        .then((workerTypes) => {
          if (workerTypes) { this.workerTypes = workerTypes }
        })
        .catch(err => alert(err))
    },

    updateCategories () {
      api.getFurnitureCategories()
        .then((categories) => {
          if (categories) { this.furnitureCategories = this.furnitureCategories = categories }
        })

      api.getMoverCategories()
        .then((categories) => {
          if (categories) { this.moverCategories = this.moverCategories = categories }
        })

      api.getGarbageRemovalCategories()
        .then((categories) => {
          if (categories) { this.garbageCategories = this.garbageCategories = categories }
        })

      api.getTruckingCategories()
        .then((categories) => {
          if (categories) { this.truckingCategories = this.truckingCategories = categories }
        })
    },

    updateDistricts () {
      api.getDistricts()
        .then(districts => {
          if (districts) { this.districts = districts }
        })
    },

    equalOrderToAndWorkerType (orderToType, workerType) {
      switch (workerType) {
        case 'driver':
          return orderToType === 'OrderToTrucking'
        case 'furniture':
          return orderToType === 'OrderToFurniture'
        case 'mover':
          return orderToType === 'OrderToMover'
        case 'garbage':
          return orderToType === 'OrderToGarbage'
        default:
          return true
      }
    },

    moment (data) {
      return data ? moment(data).format('HH:mm') : moment().format('HH:mm')
    },

    addDatePickerWatcher() {
      // нужен для того, чтобы по клику на энтер в дейтпикере проставлялась новая дата, а не предыдущая

      this.$watch(
        () => {
          return this.$refs.datePicker.userInput
        },
        (newVal, oldVal) => {
          let tmpValueForDatePicker = utils.spotNewValueForDatePicker(newVal, oldVal);
          if (tmpValueForDatePicker) {
            this.dateFilter = tmpValueForDatePicker;
            this.$refs.datePicker.popupVisible = false;
            this.updateWorkersWithStartOfDay(tmpValueForDatePicker);
          } else if (tmpValueForDatePicker === null) {
            this.$refs.datePicker.userInput = '';
            this.$refs.datePicker.currentValue = null;
          }
        }
      );
    }
  }
}
</script>
